/**
 * Extracts the ID from a given Location header string.
 *
 * The function splits the input string by "/" and returns the last segment,
 * which is assumed to be the ID. Throws an error if the ID cannot be extracted.
 *
 * @param locationHeader - The Location header string from which to extract the ID.
 * @returns The extracted ID as a string.
 * @throws {Error} If the ID cannot be extracted from the Location header.
 * @example url: "https://api.example.com/resource/12345"
 */
const extractIdFromLocation = (locationHeader: string): string => {
  const id = locationHeader.split("/").pop();
  if (!id) throw new Error("Could not extract ID from Location header");
  return id;
};

export default extractIdFromLocation;
